(() => {
  function computeInStock(v) {
    if (v.inventory_management === "shopify") return Number(v.inventory_quantity) > 0;
    return true;
  }

  function parseWeight(v) {
    if (v.product_weight == null) return 0;

    let w = String(v.product_weight)
      .trim()
      .toLowerCase()
      .replace("kg", "")
      .replace(",", ".");

    const n = Number(w);
    return isNaN(n) ? 0 : n;
  }

  function isHeavy(v) {
    return parseWeight(v) >= 20;
  }

  function buildStatus(v) {

    const inStock = computeInStock(v);
    const override = (v.delivery_override || "").trim();
    const vendor = (v.product_vendor || "").trim().toLowerCase();
    const source = (v.delivery_source || "").trim().toLowerCase();
    // Backorderable only when the variant is set to keep selling when out of stock.
    // A remote source alone does NOT make a deny-policy product orderable.
    const canBuy = String(v.inventory_policy || "").toLowerCase() === "continue";

    // In-stock BERG products from 20 kg keep the longer delivery estimate.
    if (inStock) {
      return {
        text: v.pickup_only === true
          ? "Skal afhentes i Risskov"
          : isHeavy(v) && vendor === "berg"
          ? "På lager 1-3 hverdages levering"
          : "På lager 1-2 hverdages levering",
        canBuy: true,
        buttonText: "Læg i kurv",
        dotColor: "rgb(62, 214, 96)"
      };
    }

    // Out of stock and NOT backorderable -> plain "out of stock", ignore remote source.
    if (!canBuy) {
      return {
        text: "Ikke på lager",
        canBuy: false,
        buttonText: "Ikke på lager",
        dotColor: "rgb(220, 38, 38)"
      };
    }

    // 🟡 Override (ALTID først)
    if (override) {
      return {
        text: override,
        canBuy,
        buttonText: canBuy ? "Forudbestil" : "Ikke på lager",
        dotColor: "rgb(238, 148, 65)"
      };
    }

    // 🟢 BERG fjernlager (NY)
    if (source === "berg fjernlager") {
      return {
        text: "På fjernlager 1-3 hverdages levering",
        canBuy,
        buttonText: canBuy ? "Forudbestil" : "Ikke på lager",
        dotColor: "rgb(62, 214, 96)"
      };
    }

    // 🟢 BERG
    if (source === "berg") {
      return {
        text: v.theme_text_berg || "1-3 hverdages levering",
        canBuy,
        buttonText: canBuy ? "Forudbestil" : "Ikke på lager",
        dotColor: "rgb(62, 214, 96)"
      };
    }

    // 🟡 Fitness Beneluxe
    if (source === "fitness beneluxe") {
      return {
        text: v.theme_text_fitness || "5-10 hverdages levering",
        canBuy,
        buttonText: canBuy ? "Forudbestil" : "Ikke på lager",
        dotColor: "rgb(238, 148, 65)"
      };
    }

    // 🔴 fallback
    return {
      text: "Ikke på lager",
      canBuy,
      buttonText: canBuy ? "Forudbestil" : "Ikke på lager",
      dotColor: "rgb(220, 38, 38)"
    };
  }
  
  function findScope(el) {
    return el.closest("product-info") || document;
  }

  function getSelectedVariantId(scope) {
    const input = scope.querySelector('form[action*="/cart/add"] input[name="id"]');
    return input ? Number(input.value) : null;
  }

  function update(holder) {
    const scope = findScope(holder);

    let variants = [];
    try {
      variants = JSON.parse(holder.dataset.variants || "[]");
    } catch {}

    const variantId = getSelectedVariantId(scope);
    if (!variantId) return;

    const v = variants.find(x => Number(x.id) === Number(variantId));
    if (!v) return;

    const status = buildStatus(v);

    // tekst
    const textEl = holder.querySelector("[data-delivery-text]");
    if (textEl) textEl.textContent = status.text;

    // prik farve
    const dotEl = holder.querySelector("[data-delivery-dot]");
    if (dotEl) dotEl.style.color = status.dotColor;

    // The add-to-cart button is NOT touched here. Shopify renders the correct label
    // server-side ("Laeg i indkoebskurv" when purchasable, disabled "Ikke paa lager"
    // when not), and buy-buttons.liquid hides the dynamic-checkout button when out of
    // stock. Swapping to "Forudbestil" was wrong for remote/backorder and OOS items.
  }

  function initOne(holder) {
    const scope = findScope(holder);

    update(holder);

    scope.addEventListener("change", () => setTimeout(() => update(holder), 0));

    const idInput = scope.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (idInput) {
      const mo = new MutationObserver(() => update(holder));
      mo.observe(idInput, { attributes: true, attributeFilter: ["value"] });
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-delivery-status]").forEach(initOne);
  });
})();
